import { render, staticRenderFns } from "./WebhookEdit.vue?vue&type=template&id=3e4c9ec8"
import script from "./WebhookEdit.vue?vue&type=script&lang=ts"
export * from "./WebhookEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports